import React from 'react';
import {connect} from 'react-redux';
import Numeral from 'numeral';
import {clearJobDetails} from '../actions/jobAds';
import {getDiffrentTime} from '../utils/DateUtility'
import {enToFa} from '../utils/NumberUtility'
import logo from '../assets/images/C_logo.png';

const PriceAdItem = (props) => {

    return (
      <div className={`price-item ${props.classes ? props.classes : '' }`}>
        <div className="optimized__d-flex-class">
          < img className = "vehicle-ad__img col-4 px-2"
          src = {
            `https://prv.carclick.ir${props.info.targetVehicle.brand.image}`
            // props.info.images.length < 1 ? logo : props.info.images[0].image
          }
          />
          <div className="optimized__d-flex-class flex-column col-8 justify-content-between">
            <span className="vehicle-ad__title">{`${props.info.targetVehicle.brand.name} - ${props.info.targetVehicle.name}`}</span>
            <span className="vehicle-ad__elapsed-time optimized__d-flex-class align-items-center justify-content-between">
              <span className="price-item__detail"><span><i className="simple-icon-clock vehicle-ad__elapsed-logo"></i></span><span>{enToFa(getDiffrentTime(props.info.lastUpdate))}</span></span>
              <span className="price-item__detail"><span className="stock__span"><i class="material-icons stock__i">timeline</i></span><span className="price-item__price-change">{enToFa(`${props.info.changePercentage}%`)}</span></span>
            </span>
            <div className="optimized__d-flex-class justify-content-between align-items-center">
              <span className="vehicle-ad__price">{`${enToFa(Numeral(props.info.price).format('0,0'))} تومان`}</span>
            </div>
          </div>
        </div>
        {/* <div className="optimized__d-flex-class justify-content-start align-items-center mt-2">
            <span>
              <i className="simple-icon-location-pin vehicle-ad__location-logo"></i>
            </span>
            <span className="vehicle-ad__location">{props.sharedElement ? props.info.area  : `${props.info.city.state.name}، ${props.info.city.name}`}</span>
        </div> */}
      </div>
    );
}

const mapDispatchToProps = (dispatch) => ({
  clearJobDetails: () => {dispatch(clearJobDetails)}
})

export default connect(undefined, mapDispatchToProps)(PriceAdItem);